import { LoadingButton } from '@mui/lab';
import { Button, Stack, Typography } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { useAuthContext } from 'src/auth/hooks';
import { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { getOrganizationDetails, getOrganizationId, putOrgDetails, resetTemplateApi } from 'src/services/user.service';
import { LoadingScreen } from 'src/components/loading-screen';
import { setLoading } from 'src/store/modalSlice';

const EmailTemplate = () => {
    const htmlText = useRef("");
    const [copySuccess, setCopySuccess] = useState("");
    const [placeHolders, setPlaceholders] = useState([
        {
            value: "{company}",
            label: "Company Name"
        },
        {
            value: "{jobName}",
            label: "Job Name"
        },
        {
            value: "{user_name}",
            label: "Sender's Name"
        },
        {
            value: "{expiry_date}",
            label: "Valid Till"
        }
    ]);
    const [subject, setSubject] = useState("Virtual interview link for {jobName} @ {company}")
    const [reset, setReset] = useState(false);
    const [loading, setLoading] = useState(false);
    const { user } = useAuthContext();
    const org_id = getOrganizationId(user);

    const handleChange = (content, editor) => {
        // console.log(content)
        htmlText.current = content;
    };
    const handleCopyClick = item => {
        navigator.clipboard.writeText(item.value).then(
            () => {
                enqueueSnackbar(`${item.label} copied to clipboard !`)
                setCopySuccess(item.value);

                setTimeout(() => {
                    setCopySuccess("");
                }, 1000);
            },
            () => {

            },
        );
    };

    const saveTemplate = async () => {
        const payload = {
            "email_template": htmlText.current,
            "subject_template": subject
        }
        // console.log(payload)
        const res = await putOrgDetails(payload, org_id);
        console.log("save template", res);
        if (res.success) {
            enqueueSnackbar("Saved successfully...");
        }
        else {
            enqueueSnackbar({ message: "Saving failed.. Please try again later...", variant: "error" })
        }
    }

    const callerFunc = async () => {
        try {
            const res = await getOrganizationDetails(org_id);
            console.log("caller", res);
            if (res.success) {
                setSubject(res.body.subject_template);
                htmlText.current = res.body.email_template;
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const resetTemplate = async () => {
        const payload = {
            "template_type": "INTERVIEW_INVITE"
        }
        const res = await resetTemplateApi(payload, org_id);
        console.log("reset", res);
        // setSubject(res.body.subject_template);
        // setTimeout(() => {
        //     htmlText.current = res.body.email_template;
        // }, 1000);
        setReset((prev) => !prev)
        if (res.success) {
            enqueueSnackbar("Email reset successfully...");
        }
        else {
            enqueueSnackbar({ message: "Reset failed.. Please try again later...", variant: "error" })
        }
    }

    useEffect(() => {
        setLoading(true);
        callerFunc();
    }, [reset]);

    return (

        <>
            {loading && (
                <Stack
                    sx={{ height: '100%', display: 'flex', justifyContent: 'end', alignItems: "end" }}
                >
                    <LoadingScreen loadingText="" />
                </Stack>
            )}
            {!loading && <>
                <Stack alignItems="flex-start" justifyContent="center" sx={{ width: "100%", marginBottom: "1.5rem" }} >
                    <Typography variant="h6" sx={{ marginBottom: "0.8rem" }}>Subject</Typography>
                    <input style={{ width: "100%", padding: "0.5rem", fontSize: "1rem" }} value={subject} onChange={(e) => setSubject(e.target.value)} type="text"></input>
                </Stack>

                <Stack >
                    <Typography variant="h6" sx={{ marginBottom: "0.8rem" }}>Body</Typography>
                    <Stack sx={{
                        // border: "1px solid grey",
                        // borderRadius: "5px", 
                        padding:"0.4rem",
                        display: "flex",
                        flexDirection: "row"
                    }}>
                        <Typography sx={{ fontWeight: "600", marginRight:"1rem" }}>Variables</Typography>

                        <Stack sx={{ display: "flex", flexDirection: "row", gap: "1rem", flexWrap: "wrap" }}>
                            {placeHolders.map(item => (
                                <Stack sx={{ display: "flex", flexDirection: "row" }}>
                                    <Typography>{item.label}</Typography>
                                    <Button
                                        sx={{ minWidth: "30px", padding: "0px", paddingBottom: "5px" }}
                                        disabled={copySuccess === item.value}
                                        onClick={() =>
                                            handleCopyClick(
                                                item
                                            )
                                        }
                                    ><Iconify icon="ph:copy" width={18} /></Button>
                                </Stack>
                            ))}
                        </Stack>


                    </Stack>
                    <Editor
                        style={{ borderRadius: "0px" }}
                        apiKey={process.env.REACT_APP_TINYMCE_API}
                        onInit={(evt, editor) => htmlText.current = editor}
                        initialValue={htmlText.current}
                        init={{
                            height: 500,
                            menubar: false,
                            plugins: [
                                'advlist', 'autolink', 'lists', 'link', 'image', 'charmap', 'preview',
                                'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
                                'insertdatetime', 'media', 'table', 'code', 'help', 'wordcount'
                            ],
                            toolbar: 'undo redo | blocks | ' +
                                'bold italic forecolor | alignleft aligncenter ' +
                                'alignright alignjustify | bullist numlist outdent indent | ' +
                                'removeformat | help',
                            content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'
                        }}
                        onEditorChange={handleChange}
                    />
                    <Stack sx={{ display: "flex", flexDirection: "row", gap: "2rem", alignItems: "center", justifyContent: "center", marginTop: "2rem" }}>
                        <LoadingButton variant="outlined" sx={{ border: "1px solid black", width: "8rem" }} onClick={resetTemplate} type="submit" loading={false}>
                            Reset
                        </LoadingButton>
                        <LoadingButton sx={{ width: "8rem" }} onClick={saveTemplate} type="submit" variant="contained" loading={false}>
                            Save Changes
                        </LoadingButton>
                    </Stack>
                </Stack>
            </>

            }
        </>

    )

};
export default EmailTemplate;